import {useTranslations} from 'next-intl';
import {Row, Col} from '@/grid';
import Container from '@/container';
import BoxGrid from '@/ui/box-grid';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';
import {H4, PNoMargin} from '@/typography';
import {withMarginBottomXs} from '@/hocs/withSpacing';
import {SectionSpacedTopLgToDouble} from '@/section';
import type {AgentChangesCard} from '@/content/workable-ai/types';
import {BgPurple100Div, Grid, H2MarginedMd, TitleBlock} from '@/content/workable-ai/shared';
import styles from '../agent-delivers-section/agent-delivers-section.module.scss';

const H4MarginedXs = withMarginBottomXs(H4 as never);

const AgentChangesSection = () => {
  const t = useTranslations('workableAi.agentChanges');
  const cards = t.raw('cards') as AgentChangesCard[];

  return (
    <BgPurple100Div>
      <SectionSpacedTopLgToDouble>
        <Container>
          <Grid fluid>
            <Row center="xs">
              <Col xs={12} md={10}>
                <H2MarginedMd>{t('title')}</H2MarginedMd>
                <TitleBlock>
                  <PNoMargin>{t('subtitle')}</PNoMargin>
                </TitleBlock>
              </Col>
            </Row>

            <div className={styles['cards-grid']}>
              <GridLayout Col={4} lgCol={2} autoRows>
                {cards.map(({id, title, body}) => (
                  <GridItem key={id}>
                    <BoxGrid backgroundColor="var(--neutral50)">
                      <H4MarginedXs>{title}</H4MarginedXs>
                      <PNoMargin>{body}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                ))}
              </GridLayout>
            </div>
          </Grid>
        </Container>
      </SectionSpacedTopLgToDouble>
    </BgPurple100Div>
  );
};

export default AgentChangesSection;
